function getCache(r) {
  let cache = {};
  r.keys().forEach(key => {
    cache = Object.assign(cache, r(key).default);
  });

  return cache;
}

const en = getCache(require.context("./en"));
const hi = getCache(require.context("./hi"));
const mr = getCache(require.context("./mr"));
const pa = getCache(require.context("./pa"));
const te = getCache(require.context("./te"));
const ta = getCache(require.context("./ta"));
const kn = getCache(require.context("./kn"));

export default {
  en: en,
  hi: hi,
  kn: kn,
  mr: mr,
  ta: ta,
  te: te,
  pa: pa
};